var React = require('react');

function StopNowIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#qqc16gjiea)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.573 15.174c-.147.536-.73.804-1.253.612-.523-.192-.785-.77-.647-1.31a9.984 9.984 0 1 0-8.849 7.473c.555-.046 1.081.31 1.183.857.102.548-.26 1.078-.814 1.134a12 12 0 1 1 10.38-8.767zM12 5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2h-3V6a1 1 0 0 0-1-1zm5 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4z","fill":"#fff"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"qqc16gjiea"},React.createElement("path",{"fill":"#fff","d":"M0 0h24v24H0z"})))]);
}

StopNowIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = StopNowIcon;

StopNowIcon.default = StopNowIcon;
